import { render, staticRenderFns } from "./corporateMealPlanForm.vue?vue&type=template&id=6ded63c2&"
import script from "./corporateMealPlanForm.vue?vue&type=script&lang=js&"
export * from "./corporateMealPlanForm.vue?vue&type=script&lang=js&"
import style0 from "./corporateMealPlanForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports